import { Component, ViewChild } from '@angular/core';
import { take } from 'rxjs/operators';
import { STATUS, EoFormComponent } from 'ngx-eo-web-components';
import { AuthService } from '../../../../services/auth/auth.service';
import { CoreService } from '../../core.service';

import {
  forgotPasswordFormConfig,
  forgotPwdSubmitLabel,
} from './forgot-password-form.config';

@Component({
  selector: 'app-forgot-password-dialog',
  templateUrl: './forgot-password-dialog.component.html',
})
export class ForgotPasswordDialogComponent {
  @ViewChild('eoForm') eoForm?: EoFormComponent;

  readonly formConfig = forgotPasswordFormConfig;
  readonly submitLabel = forgotPwdSubmitLabel;

  visible = false;
  readonly status$ = this.authService.forgotPasswordCh.status$;

  constructor(private authService: AuthService, private core: CoreService) {}

  show(): void {
    this.visible = true;
    this.eoForm?.getForm()?.reset();
  }

  hide(): void {
    this.visible = false;

    this.authService.forgotPasswordCh.status$.next(STATUS.pending);
  }

  onSubmit(ev: any): void {
    const { username, email } = ev.request ?? {};
    if (!username || !email) return;

    this.authService
      .forgotPassword({ username, email })
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.core.showSuccess(
            'Ένας σύνδεσμος επαναφοράς κωδικού έχει σταλεί στο email σας. Αν δεν τον δείτε σύντομα, ελέγξτε και τον φάκελο ανεπιθύμητης αλληλογραφίας.',
            'Επιτυχία'
          );
          this.hide();
        },
      });
  }

  isLoading(): boolean {
    return this.status$.getValue() === STATUS.loading;
  }
}
